<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <div class="ziro-content">
    <div class="mx-4 flex-grow-1">
      <ziro-uccx-agent-form
        [entity]="uccxAgent"
        [uccxAgentRef]="uccxAgentRef"
        [fieldConfig]="fieldConfig"
        [resourceGroups]="resourceGroups"
      ></ziro-uccx-agent-form>
    </div>
  </div>
}
